import React from 'react';
import ReactDOM from 'react-dom/client';
import App from 'mdui/page/App';
import reportWebVitals from './reportWebVitals';
import 'mdb-react-ui-kit/dist/css/mdb.min.css';
import './index.css';
import { I18nextProvider } from 'react-i18next';
import i18n from './locales/i18n';
import { UtilProvider } from 'mdui/page/UtilProvider';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <I18nextProvider i18n={i18n}>
      <UtilProvider>
        <App />
      </UtilProvider>
    </I18nextProvider>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
